import React from "react";
import { Link } from "react-router-dom";

import PerfectScrollbar from "react-perfect-scrollbar";

import useSidebar from "../../hooks/useSidebar";
import SidebarNav from "./SidebarNav";
import Logo from "../../assets/img/fonda-logo.png";

const Sidebar = ({
    title,
    items,
    showFooter = true,
    app = "",
    homeUrl = null,
}) => {
    const { isOpen } = useSidebar();

    // An explicit homeUrl wins; otherwise fall back to the old behavior
    const dashboardUrl =
        homeUrl ?? (app !== "" ? `/${app.toLowerCase()}` : "/");

    return (
        <nav className={`sidebar ${!isOpen ? "collapsed" : ""}`}>
            <div className="sidebar-content">
                <PerfectScrollbar>
                    <Link className="sidebar-brand" to={dashboardUrl}>
                        <img
                            src={Logo}
                            alt="Fonda logo"
                            style={{
                                maxWidth: "55px",
                            }}
                        />{" "}
                        <span className="align-middle me-3">{title}</span>
                    </Link>

                    <SidebarNav items={items} />
                </PerfectScrollbar>
            </div>
        </nav>
    );
};

export default Sidebar;